import { render, staticRenderFns } from "./ListGroupHeadFee.vue?vue&type=template&id=02c72d3b&scoped=true"
import script from "./ListGroupHeadFee.vue?vue&type=script&lang=js"
export * from "./ListGroupHeadFee.vue?vue&type=script&lang=js"
import style0 from "./ListGroupHeadFee.vue?vue&type=style&index=0&id=02c72d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c72d3b",
  null
  
)

export default component.exports